// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/sales/sample-request/${file}.vue`);

export default [
    {
        path: "/sample-request",
        name: "sample-request-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SampleRequests",
        },
        components: {
            content: lazyLoad('sample-request-list'),
        },
    },
    {
        path: "/sample-request/create*",
        name: "sample-request-create",
        meta: { requiresAuth: true, applicationFeatureCode: "SampleRequests" },
        components: {
            content: lazyLoad('sample-request'),
        },
    },
    {
        path: "/sample-request/review/:id",
        name: "sample-request-review",
        meta: { requiresAuth: true, applicationFeatureCode: "SampleRequests" },
        components: {
            content: lazyLoad('sample-request'),
        },
    },
    {
        path: "/sample-request/edit/:id",
        name: "sample-request-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "SampleRequests" },
        components: {
            content: lazyLoad('sample-request'),
        },
    },
]; 